module.exports = __webpack_public_path__ + "img/RealEstateAwards_logo_black_hatszog.e4cff3cc.png";